import SVGProps from 'src/components/icons/config/svg-props' //
// Auto-generated file created by svgr-cli source svg-template.cjs
// Run npm run generate-icons to update
// Do not edit
const SvgComputerIcon = (props: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    fill="none"
    viewBox="0 0 64 64"
    role="img"
    className="icon"
    {...props}
  >
    <path
      fill="currentColor"
      d="M8.333 13.667A2.667 2.667 0 0 1 11 11h42.667a2.667 2.667 0 0 1 2.666 2.667v26.666H59A2.667 2.667 0 0 1 61.667 43v8A2.667 2.667 0 0 1 59 53.667H5.667A2.667 2.667 0 0 1 3 51v-8a2.667 2.667 0 0 1 2.667-2.667h2.666zM11 40.333h42.667V13.667H11zm24-18.666H16.333V19H35zM5.667 43v8H59v-8z"
    />
  </svg>
)
export default SvgComputerIcon
